// Format date only (no time) without timezone conversion
// Extracts the UTC date from ISO strings to avoid timezone conversion issues
// E.g., "2025-10-19T01:59:59.999+02:00" (which is 2025-10-18 23:59:59.999 UTC) -> "18/10/2025"
export const formatDateOnly = (dateString: string | null | undefined | Date): string => {
  if (!dateString) {
    return '-'
  }

  // Parse as Date object to handle timezone conversion
  const date = dateString instanceof Date ? dateString : new Date(dateString)

  // Use UTC methods to get the original UTC date, avoiding timezone conversion
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')

  // Format as DD/MM/YYYY
  return `${day}/${month}/${year}`
}

// Format date to ISO format (YYYY-MM-DD) using local timezone
// Used when sending dates to backend to avoid timezone shift issues
// E.g., Date object for "Feb 3, 2026" in Paris (UTC+1) -> "2026-02-03" (not "2026-02-02")
export const formatDateToLocalISO = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// Format date and time as DD/MM/YYYY HH:mm using local timezone
export const formatDateTime = (dateString: string | null | undefined | Date): string => {
  if (!dateString) {
    return '-'
  }

  const date = dateString instanceof Date ? dateString : new Date(dateString)

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${day}/${month}/${year} ${hours}:${minutes}`
}

// Format time to HH:mm using local timezone
// Used when sending time fields to backend
export const formatTimeToLocalHHMM = (date: Date): string => {
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${hours}:${minutes}`
}
